export const SET_TESTS_VARIATIONS_FULLY = 'SET_TESTS_VARIATIONS_FULLY'
export const UPDATE_VARIATIONS_DOMAIN_FULLY = 'UPDATE_VARIATIONS_DOMAIN_FULLY'
export const SET_YANDEX_AB_INIT_COUNT = 'SET_YANDEX_AB_INIT_COUNT'
export const SET_AB_FLAGS = 'SET_AB_FLAGS'
